function ProductPageWidgetFactory(container) {
  class ProductPageWidget {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.customerStatus = document
        .querySelector(`html`)
        .classList.contains("customer-guest")
        ? `guest`
        : `customer`;
      this.ProfilePageWidget = container;

      this._init();
    }
    appendHtml(selector, htmlContent, position = "beforeend") {
      const div = selector;
      if (div) {
        div.insertAdjacentHTML(position, htmlContent);
      } else {
        console.warn(`Element with selector "${selector}" not found.`);
      }
    }

    _renderRegistryButton() {
      let registryButton = this.ProfilePageWidget.querySelector(
        `.giftreggie-pdp-registry-cta--button`
      );
      if (registryButton) {
        if (this.customerStatus === `guest`) {
          registryButton.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = `/account/login?source=add_to_registry`;
          });
        }
      }
    }
    _init() {
      this._renderRegistryButton();
      this._setEvents();
    }
    _setEvents() {}
  }
  return new ProductPageWidget(container);
}
// ${window.themeVariables.translations.profilepage.profilepagePageTitle}
